// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withCookies } from "react-cookie";

import { setTokenFromCookie } from "../../Actions/CookieWorker/cookieworker";
import { setActiveLanguage } from "react-localize-redux";

type PropsType = {
  cookies: Object,
  setTokenFromCookie: string => void,
  setActiveLanguage: string => void
};

type StateType = {};

class CookieWorker extends Component<PropsType, StateType> {
  constructor(props: Object) {
    super(props);

    this._handleCookieRetrieve();
  }

  _handleCookieRetrieve = () => {
    const envanteriumCookie = this.props.cookies.get("envanterium");

    if (envanteriumCookie) {
        const { token, activeLanguage } = envanteriumCookie;

        if (token) {
            this.props.setTokenFromCookie(token);
        }
        if (activeLanguage) {
            this.props.setActiveLanguage(activeLanguage);
        }
    }
  };

  render() {
    return <div />;
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setTokenFromCookie,
      setActiveLanguage
    },
    dispatch
  );
};

export default connect(
  null,
  mapDispatchToProps
)(withCookies(CookieWorker));



// WEBPACK FOOTER //
// ./src/Utilities/Workers/CookieWorker.js